import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import Login from "@/pages/Login";
import TokenIssuer from "@/pages/TokenIssuer";
import Registration from "@/pages/Registration";
import PhysicalExamMale from "@/pages/PhysicalExamMale";
import PhysicalExamFemale from "@/pages/PhysicalExamFemale";
import BloodCollection from "@/pages/BloodCollection";
import XRay from "@/pages/XRay";
import UnifiedDisplay from "@/pages/displays/UnifiedDisplay";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/token-issuer" element={<TokenIssuer />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/physical-exam-male" element={<PhysicalExamMale />} />
          <Route path="/physical-exam-female" element={<PhysicalExamFemale />} />
          <Route path="/blood-collection" element={<BloodCollection />} />
          <Route path="/xray" element={<XRay />} />
          <Route path="/display" element={<UnifiedDisplay />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;